import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import "./BMTable.scss";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  BookMakers,
  EventData,
  Runners,
} from "../../models/EventData";
import "../MatchOddsTable/MatchOddsTable.scss"
import MarketOddBtn from "../MarketOddBtn/marketOddBtn";
import { addExchangeBet } from "../../store/exchBetSlip/exchBetSlipAction";
import moment from "moment";
import { BsData, UserBet } from "../../models/ExchBetSlip";
import ExchBetSlip from "../ExchBetSlip/ExchBetSlip";
import { ExpandLessSharp } from "@mui/icons-material";

type StoreProps = {
  bets: BsData[];
  addExchangeBet: (data: BsData) => void;
  eventData: EventData;
  bmMarkets: BookMakers[];
  openBetsData: UserBet[];
};

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

const BMTable: React.FC<StoreProps> = (props) => {
  const { bmMarkets, bets, eventData, openBetsData, addExchangeBet } = props;
  const [selectedRow, setSelectedRow] = useState<string>("");
  const disabledStatus = [
    'suspended',
    'closed',
    'suspended-manually',
    'suspended manually',
    'ball_running',
    'ball running'
  ];

  const getTotalPL = (
    marketId: string,
    runner: Runners
  ) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) => b.marketId === marketId && b.stakeAmount && b.stakeAmount > 0
    );
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(marketId, runner);
      for (let bet of mBetslipBets) {
        const plVal = (bet.oddValue / 100 + 1) * bet.stakeAmount - bet.stakeAmount;
        if (bet.betType === "BACK") {
          if (bet.runnerId === runner.runnerId) {
            returns ? (returns += plVal) : (returns = plVal);
          } else {
            returns
              ? (returns -= bet.stakeAmount)
              : (returns = 0 - bet.stakeAmount);
          }
        } else if (bet.betType === "LAY") {
          if (bet.runnerId !== runner.runnerId) {
            returns
              ? (returns += bet.stakeAmount)
              : (returns = bet.stakeAmount);
          } else {
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          }
        }
      }
    }
    return [returns];
  };

  const getOpenBetsPL = (
    marketId: string,
    runner: Runners
  ) => {
    let returns = null;

    if (openBetsData && openBetsData.length > 0) {
      const mOpenBets = openBetsData.filter((b: any) => b.marketId === marketId);
      for (let bet of mOpenBets) {
        const plVal = (bet.oddValue / 100 + 1) * bet.stakeAmount - bet.stakeAmount;
        if (bet.betType === "BACK") {
          if (bet.runnerId === runner.runnerId) {
            returns ? (returns += plVal) : (returns = plVal);
          } else {
            returns
              ? (returns -= bet.stakeAmount)
              : (returns = 0 - bet.stakeAmount);
          }
        } else if (bet.betType === "LAY") {
          if (bet.runnerId !== runner.runnerId) {
            returns
              ? (returns += bet.stakeAmount)
              : (returns = bet.stakeAmount);
          } else {
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          }
        }
      }
    }
    const retVal = returns ? returns : null;
    return retVal;
  };

  const getOpenBetsPLInArray = (
    marketId: string,
    runner: Runners
  ) => {
    return [getOpenBetsPL(marketId, runner)];
  };

  return (
    <>
      <div className="bm-table-ctn matchodds-table-ctn">
        <div className="bm-table-content table-ctn matchodds-table-content">
          {bmMarkets && bmMarkets?.length > 0
            ? bmMarkets.map((market, index) => {
              return (
                <>
                  <Accordion
                    defaultExpanded={true}
                    className="markets-accordian">
                    <AccordionSummary
                      expandIcon={
                        <ExpandLessSharp className="expand-icon" />
                      }
                      aria-controls="panel1a-content"
                    >
                      <TableRow
                        className="acc-head"
                      >
                        <TableCell
                          colSpan={3}
                          className="acc-cell"
                        >
                          <div className="market-name-cell-head-ctn">
                            <div className="market-name">
                              {market.marketName}
                            </div>
                            <span className="bet-limits-section mob-view">
                              <div>
                                MIN:{market?.limits?.minBetValue
                                  ? market?.limits?.minBetValue
                                  : "100"}&nbsp;
                              </div>
                              <div>
                                MAX:{market?.limits?.maxBetValue
                                  ? market?.limits?.maxBetValue %
                                    1000 ==
                                    0
                                    ? market?.limits?.maxBetValue /
                                    1000 +
                                    "K"
                                    : market?.limits?.maxBetValue
                                  : "5K"}
                              </div>
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </AccordionSummary>
                    <AccordionDetails>
                      <TableContainer key={index} component={Paper}>
                        <Table className="bm-table">
                          <TableBody>
                            <TableRow className="header-row">
                              <TableCell colSpan={1} align="left" className="market-name-cell-head">
                                <div className="teamname-odd">Market</div>
                              </TableCell>
                              <TableCell colSpan={1} align="right" className="odds-cell-head">
                                <div className="back-odd">
                                  BACK
                                </div>
                              </TableCell>
                              <TableCell colSpan={1} align="left" className="odds-cell-head">
                                <div className="lay-odd">
                                  LAY
                                </div>
                              </TableCell>
                            </TableRow>
                            {market.runners?.length > 0 ? (
                              <>
                                {market.runners.map((runner) => (
                                  <BmOddsRow
                                    getOpenBetsPL={getOpenBetsPLInArray}
                                    getTotalPL={getTotalPL}
                                    market={market}
                                    runner={runner}
                                    addExchangeBet={addExchangeBet}
                                    disabledStatus={disabledStatus}
                                    eventData={eventData}
                                    marketName={market.marketName}
                                    marketId={market.marketId}
                                    bets={bets}
                                    selectedRow={selectedRow}
                                    setSelectedRow={setSelectedRow}
                                    index={index}
                                    min={
                                      market?.limits?.minBetValue
                                        ? market?.limits?.minBetValue
                                        : 0
                                    }
                                    max={
                                      market?.limits?.maxBetValue
                                        ? market?.limits?.maxBetValue
                                        : 0
                                    }
                                  />
                                ))}
                              </>
                            ) : (
                              <>
                                <TableRow>
                                  <TableCell colSpan={3}>
                                    <div className="fm-table-msg-text">
                                      No Book Maker for this event
                                    </div>
                                  </TableCell>
                                </TableRow>
                              </>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                </>
              );
            })
            : null}
        </div>
      </div>
    </>
  );
};

type MatchOddsRowProps = {
  getOpenBetsPL: (
    marketId: string,
    runner: Runners,
    type: string
  ) => any;
  getTotalPL: (
    marketId: string,
    runner: Runners
  ) => any;
  marketId: string;
  runner: Runners;
  disabledStatus: string[];
  bets: BsData[];
  addExchangeBet: (data: BsData) => void;
  eventData: EventData;
  marketName: string;
  selectedRow: string;
  setSelectedRow: (data: any) => void;
  index: number;
  min: number;
  max: number;
  market: BookMakers;
};

const BmOddsRow: React.FC<MatchOddsRowProps> = (props) => {
  const {
    marketId,
    runner,
    addExchangeBet,
    disabledStatus,
    eventData,
    marketName,
    bets,
    selectedRow,
    setSelectedRow,
    getOpenBetsPL,
    getTotalPL,
    index,
    min,
    max,
    market
  } = props;

  return (
    <>
      <TableRow>
        <TableCell className="team-name-cell">
          <div className="team">{runner.runnerName}
            {getOpenBetsPL(
              marketId,
              runner,
              'array'
            ).map((ret: any) =>
              ret !== null ? (
                <span className={ret >= 0 ? 'profit' : 'loss'}>
                  {ret > 0
                    ? '+' + Number(ret).toFixed(2)
                    : Number(ret).toFixed(2)}
                </span>
              ) : null
            )}
          </div>
          {getTotalPL(
            marketId,
            runner
          ).map((ret: any) =>
            ret !== null ? (
              <div className="profit-loss-box">
                <span className={ret >= 0 ? 'profit' : 'loss'}>
                  {ret > 0
                    ? '+' + Number(ret).toFixed(2)
                    : Number(ret).toFixed(2)}
                </span>
              </div>
            ) : null
          )}
        </TableCell>
        <TableCell className="odds-cell">
          <div className="odds-block">
            <MarketOddBtn
              mainValue={
                runner.backPrices && runner.backPrices[0]
                  ? runner.backPrices[0].price
                  : 0
              }
              subValue={
                runner.backPrices && runner.backPrices[0]
                  ? runner.backPrices[0].size
                  : 0
              }
              showSubValueinKformat={true}
              oddType="back-odd"
              valueType="bookmakerOdds"
              disable={
                disabledStatus.includes(eventData?.status?.toLowerCase()) ||
                disabledStatus.includes(market?.status?.toLowerCase()) ||
                disabledStatus.includes(runner?.status?.toLowerCase()) ||
                moment(eventData?.openDate).diff(
                  moment(),
                  'minutes'
                ) >
                60 * 24 * 2
              }
              onClick={() => {
                addExchangeBet({
                  eventId: eventData?.eventId,
                  eventName: eventData?.eventName,
                  marketId: marketId,
                  marketName: marketName,
                  marketType: "BOOKMAKER",
                  oddValue:
                    runner.backPrices && runner.backPrices[0]
                      ? runner.backPrices[0].price
                      : 0,
                  betType: "BACK",
                  stakeAmount: 0,
                  runnerId: runner.runnerId,
                  runnerName: runner.runnerName,
                  competitionId: eventData?.competitionId,
                  sportId: eventData?.sportId,
                  maxLimit: max,
                  minLimit: min,
                  provider: eventData?.markets?.bookMakerProvider || ""
                });
                setSelectedRow(runner.runnerId + marketName + "BOOKMAKER");
              }}
            />
          </div>
        </TableCell>
        <TableCell className="odds-cell">
          <div className="odds-block">
            <MarketOddBtn
              mainValue={
                runner.layPrices && runner.layPrices[0]
                  ? runner.layPrices[0].price
                  : 0
              }
              subValue={
                runner.layPrices && runner.layPrices[0]
                  ? runner.layPrices[0].size
                  : 0
              }
              showSubValueinKformat={true}
              oddType="lay-odd"
              valueType="bookmakerOdds"
              disable={
                disabledStatus.includes(eventData?.status?.toLowerCase()) ||
                disabledStatus.includes(market?.status?.toLowerCase()) ||
                disabledStatus.includes(runner?.status?.toLowerCase()) ||
                moment(eventData?.openDate).diff(
                  moment(),
                  'minutes'
                ) >
                60 * 24 * 2
              }
              onClick={() => {
                addExchangeBet({
                  eventId: eventData?.eventId,
                  eventName: eventData?.eventName,
                  marketId: marketId,
                  marketType: "BOOKMAKER",
                  marketName: marketName,
                  oddValue:
                    runner.layPrices && runner.layPrices[0]
                      ? runner.layPrices[0].price
                      : 0,
                  betType: "LAY",
                  stakeAmount: 0,
                  runnerId: runner.runnerId,
                  runnerName: runner.runnerName,
                  competitionId: eventData?.competitionId,
                  sportId: eventData?.sportId,
                  maxLimit: max,
                  minLimit: min,
                  provider: eventData?.markets?.bookMakerProvider || ""
                });

                setSelectedRow(runner.runnerId + marketName + "BOOKMAKER");
              }
              }
            />
          </div>
        </TableCell>
        {/* {
        disabledStatus.includes(eventData?.status?.toLowerCase()) ||
          disabledStatus.includes(market.status?.toLowerCase()) ? (
          <div className="disabled-odds-cell" key={'row-' + index + 'cell-5'}>
            {market.status?.toLowerCase().includes('suspended')
              || runner.status.includes(market.status?.toLowerCase())
              ? 'SUSPENDED'
              : market.status?.toLowerCase().replace('_', ' ')}
          </div>
        ) : null} */}
      </TableRow>
      {bets?.length > 0 &&
        bets?.[0]?.marketName === marketName &&
        bets?.[0]?.marketId === marketId &&
        bets?.[0]?.runnerId === runner.runnerId &&
        // isMobile ? (
        <TableRow className="inline-betslip">
          <TableCell colSpan={3}>
            {' '}
            <ExchBetSlip balance={0} exposure={0} />{' '}
          </TableCell>
        </TableRow>
        // ) : null
      }
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.exchBetSlip.bets,
    eventData: state.exchangeSports.eventInfo,
    openBetsData: state.exchBetSlip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BMTable);
